import { Field } from "formik";
import React, { memo } from "react";
import DSwitch from "../../DSwitch";

const SwitchField = ({ name, id, label, ...rest }) => {
    return (
        <Field name={name} {...rest}>
            {({ field }) => {
                return (
                    <DSwitch {...field} isChecked={field.value} label={label} />
                );
            }}
        </Field>
    );
};

export default memo(SwitchField);
